import ImagesList from './imagesList'

export default ImagesList
